import {
  getConexion,
  postConexion,
  deleteConexion,
  putConexion,
} from '../../conexion/Conexion';

export const getAllUsers = () => async () => {
  const users = await getConexion('users/allUsers');

  return users;
};

export const getAllBusines = () => async () => {
  const business = await getConexion('cash/getAllBusiness');
  return business;
};

export const createBusiness = async (objUser: any): Promise<void> => {
  await postConexion('cash/business', objUser);
};

export const changePassword = async (objUser: any): Promise<void> => {
  await postConexion('users/changePass', objUser);
};

export const updateUser = async (objUser: any): Promise<void> => {
  await postConexion('users/updateUserProfile', objUser);
};

export const deleteUser = async (objUser: any): Promise<void> => {
  await deleteConexion('users/deleteUser', objUser);
};

export const deleteProvider = async (objUser: any): Promise<void> => {
  await deleteConexion('proveedor/deleteProveedor', objUser);
};

export const resetPassword = async (objUser: any): Promise<void> => {
  await postConexion('users/reset-password', objUser);
};

export const updateOboarding = async (objUser: any): Promise<void> => {
  await putConexion('users/updateUserProfile', objUser);
};

export const register = async (objUser: any): Promise<void> => {
  await postConexion('users/createUserAndBus', objUser);
};

export const sendErp = async (objUser: any): Promise<void> => {
  await postConexion('cash/sendErpForm', objUser);
};

export const updateFirstStep = async (objUser: any): Promise<void> => {
  await putConexion('cash/business', objUser);
};
